import { z } from 'zod'
export const setPresentationAsViewedSchema = z.object({
  presentationId: z.string().uuid(),
})
export type SetPresentationAsViewed = z.infer<
  typeof setPresentationAsViewedSchema
>
